<template>
  <o-scroll>
    <div class="p-4 sm:p-10">
      <div class="flex items-center justify-between mb-4">
        <div>
          <h3 class="font-semibold">
            {{ $t('components.integration.edit.integrations.square.tabs.devices.title') }}
          </h3>
        </div>

        <div class="flex items-center space-x-2">
          <o-button variant="primary" @click="handleConnectDevice">
            {{ $t('components.integration.edit.integrations.square.pairTerminal') }}
          </o-button>
        </div>
      </div>
      <div class="border rounded bg-gray-50 dark:bg-gray-800">
        <p v-if="loading" class="p-4 text-center text-sm opacity-75">
          {{ $t('general.loadingEllipses') }}
        </p>

        <p v-if="!loading && !devices.length" class="p-4 text-center text-sm opacity-75">
          {{ $t('components.integration.edit.integrations.square.tabs.devices.noDevices') }}
        </p>

        <template v-if="!loading && devices">
          <div v-for="device in devices" :key="device.id" class="p-4 border-b flex items-center justify-between">
            <div>
              <h3 class="text-lg font-semibold">
                {{ device.name }}
              </h3>
              <p class="text-sm opacity-75">
                {{ device.status }}
              </p>
            </div>

            <div class="flex items-center space-x-1">
              <o-button size="sm" flat outline @click="handleRenameDevice(device)">
                {{ $t('components.integration.edit.integrations.square.tabs.devices.rename') }}
              </o-button>

              <!--<o-button variant="danger" size="sm" flat @click="handleRemoveDevice(device)">
                Remove
              </o-button>-->
            </div>
          </div>
        </template>
      </div>
    </div>

    <connect-device-dialog ref="connectDeviceDialog" :integration="integration" @confirm="fetchDevices(false)" />

    <rename-device-dialog ref="renameDeviceDialog" :integration="integration" @success="fetchDevices(false)" />

    <remove-device-dialog ref="removeDeviceDialog" :integration="integration" @success="fetchDevices(false)" />
  </o-scroll>
</template>

<script setup lang="ts">
import ConnectDeviceDialog from '@/components/integration/edit/integrations/square/actions/ConnectDevice.vue'
import RenameDeviceDialog from '@/components/integration/edit/integrations/square/actions/RenameDevice.vue'
import RemoveDeviceDialog from '@/components/integration/edit/integrations/square/actions/RemoveDevice.vue'

interface Props {
  integration: Record<string, any>
  options: Record<string, any> | any[]
}

const props = defineProps<Props>()
const { $api } = useNuxtApp()

const emit = defineEmits<{
  (e: 'reconnect', value: any): void
}>()

const connectDeviceDialog = ref<any>()
const renameDeviceDialog = ref<any>()
const removeDeviceDialog = ref<any>()

const loading = ref(true)
const devices = ref<any[]>([])

const fetchDevices = async (sync = true) => {
  loading.value = true

  try {
    const guid = props.integration.objectID?.() ?? props.integration.guid
    const response = await $api.integration.terminal(guid, {
      action: 'list',
      params: {
        sync,
      },
    })

    devices.value = response.data.devices
  } catch (e: any) {
    if (e?.errors?.scopes) {
      emit('reconnect', {
        message: e.errors.scopes,
      })
    }
  }

  loading.value = false
}

const handleConnectDevice = () => {
  connectDeviceDialog.value.open()
}

const handleRenameDevice = (device: any) => {
  renameDeviceDialog.value.open(device)
}

const handleRemoveDevice = (device: any) => {
  removeDeviceDialog.value.open(device)
}

onMounted(() => {
  fetchDevices()
})
</script>
